import React from "react";

import {display} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {capitalize} from "@pg-mono/nodash";
import {monthWhenVerbose, priceFormat} from "@pg-mono/string-utils";

import {PricesViewType} from "../../helpers/prices_view_type";
import {getAvgPricesText} from "../../utils/get_from_prices_type";
import {getFlatsRoomsText} from "../../utils/get_from_room_type";
import {getPercentMeaning, getPercentString} from "../../utils/percents_handling_helpers";
import {RoomsType} from "../PricesChart";

interface IProps {
    type: PricesViewType;
    roomsType: RoomsType;
    percentYearToYear?: number;
    percentMonthToMonth?: number;
    priceM2: number | undefined;
    month: number;
    regionNameWhere: string;
    isVisible: boolean;
}

export const PricesChartDescriptionText = (props: IProps) => {
    return (
        <Text variant="body_copy_2" css={display(props.isVisible ? "block" : "none")}>
            {`${capitalize(props.roomsType !== RoomsType.ONE_ROOM ? getAvgPricesText(props.type) : getAvgPricesText())} ${getFlatsRoomsText(props.roomsType)} ${
                props.regionNameWhere
            } w stanie deweloperskim w ${monthWhenVerbose(props.month)} wynoszą ${props.priceM2 ? priceFormat(props.priceM2) : "-"} za m`}
            <sup>2</sup>
            {typeof props.percentYearToYear === "number" &&
                typeof props.percentMonthToMonth === "number" &&
                `, co oznacza ${getPercentMeaning(props.percentYearToYear)} ${props.percentYearToYear != 0 ? `rzędu` : ""} ${getPercentString(
                    props.percentYearToYear
                )} rok do roku, a także ${getPercentMeaning(props.percentMonthToMonth)} ${getPercentString(
                    props.percentMonthToMonth
                )} względem ubiegłego miesiąca.`}
        </Text>
    );
};
import React from "react";

import {display} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {capitalize} from "@pg-mono/nodash";
import {monthWhenVerbose, priceFormat} from "@pg-mono/string-utils";

import {PricesViewType} from "../../helpers/prices_view_type";
import {getAvgPricesText} from "../../utils/get_from_prices_type";
import {getFlatsRoomsText} from "../../utils/get_from_room_type";
import {getPercentMeaning, getPercentString} from "../../utils/percents_handling_helpers";
import {RoomsType} from "../PricesChart";

interface IProps {
    type: PricesViewType;
    roomsType: RoomsType;
    percentYearToYear?: number;
    percentMonthToMonth?: number;
    priceM2: number | undefined;
    month: number;
    regionNameWhere: string;
    isVisible: boolean;
}

export const PricesChartDescriptionText = (props: IProps) => {
    return (
        <Text variant="body_copy_2" css={display(props.isVisible ? "block" : "none")}>
            {`${capitalize(props.roomsType !== RoomsType.ONE_ROOM ? getAvgPricesText(props.type) : getAvgPricesText())} ${getFlatsRoomsText(props.roomsType)} ${
                props.regionNameWhere
            } w stanie deweloperskim w ${monthWhenVerbose(props.month)} wynoszą ${props.priceM2 ? priceFormat(props.priceM2) : "-"} za m`}
            <sup>2</sup>
            {typeof props.percentYearToYear === "number" &&
                typeof props.percentMonthToMonth === "number" &&
                `, co oznacza ${getPercentMeaning(props.percentYearToYear)} ${props.percentYearToYear != 0 ? `rzędu` : ""} ${getPercentString(
                    props.percentYearToYear
                )} rok do roku, a także ${getPercentMeaning(props.percentMonthToMonth)} ${getPercentString(
                    props.percentMonthToMonth
                )} względem ubiegłego miesiąca.`}
        </Text>
    );
};
